export default "__VITE_ASSET__C5FJ76BE__"